import type {Component, Editor} from 'grapesjs';

export interface ModListSubOption {
  label: string;
  icon: string;
  cb: () => void;
}

export interface ModListItem {
  /** Component prop key whose truthiness drives the "-selected" highlight. */
  property?: string;
  iconClass: string;
  label: string;
  credits?: number;
  /** Action key deciding whether to show the premium/credits tag. */
  action?: string;
  callback: (editor: Editor, component: Component) => Promise<void> | void;
  subOptions?: ModListSubOption[];
}

export interface ModListDescriptor {
  listClass: string;
  items: ModListItem[];
}

export type ModListDescriptorFactory = (editor: Editor) => ModListDescriptor;

export const MOD_LIST_ACTION_REMOVE_BACKGROUND = 'remove-background';
export const MOD_LIST_ACTION_AI_IMAGES = 'open-ai-images';
/** Placeholder property for items with no `property` — useComponentProp can't be called conditionally. */
export const MOD_LIST_NO_PROPERTY = '__noop__';
